//Components
import SeoAboutProperty from '@stencil/gi-components/src/SeoAboutProperty';
import FollowUpContent from './FollowUpContent';

//Utils
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

const AboutHotel = () => {
  return (
    <div id={detailsNavigationIds.aboutProperty}>
      <SeoAboutProperty />
      <FollowUpContent />
    </div>
  );
};

export default AboutHotel;
